export default __webpack_public_path__ + "static/media/cp_geo_it.73869f99.svg";